var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dot)?_c('span',{ref:"badge",class:_vm.classes},[_vm._t("default"),_c('sup',{class:_vm.dotClasses})],2):_c('span',{ref:"badge",class:_vm.classes},[_vm._t("default"),(_vm.count)?_c('sup',{directives:[{name:"show",rawName:"v-show",value:(_vm.badge),expression:"badge"}],class:_vm.countClasses},[_vm._v(" "+_vm._s(_vm.finalCount)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }